package fr.manyverse.app.presentation.components.gm_screen

import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.MemberRole
import fr.manyverse.app.domain.model.TableMember
import fr.manyverse.app.presentation.components.player_screen.inventory.InventoryTab
import fr.manyverse.app.presentation.viewmodel.InventoryViewModel
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun GmPlayerInventorySheet(
    character: Character,
    tableId: String,
    currentUserId: String,
    tableMembers: List<TableMember>,
    characters: List<Character>,
    onDismiss: () -> Unit
) {
    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val viewModel: InventoryViewModel = koinViewModel(key = character.id) {
        parametersOf(character.id, tableId, currentUserId)
    }

    ModalBottomSheet(
        onDismissRequest = onDismiss,
        sheetState = sheetState
    ) {
        InventoryTab(
            viewModel = viewModel,
            ownerName = character.name,
            tableMembers = tableMembers.filter {
                it.role == MemberRole.PLAYER && it.characterId != character.id
            },
            characters = characters,
            modifier = Modifier.fillMaxHeight(0.9f)
        )
    }
}
